import { render, staticRenderFns } from "./Warehouse.vue?vue&type=template&id=46457b90&scoped=true&"
import script from "./Warehouse.vue?vue&type=script&setup=true&lang=js&"
export * from "./Warehouse.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Warehouse.vue?vue&type=style&index=0&id=46457b90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46457b90",
  null
  
)

export default component.exports